"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var RandomTips = (function () {
    function RandomTips($timeout) {
        var _this = this;
        this._numberOfTipsToShow = 3;
        this._rotatingTipInterval = -1;
        this.clearRotatingTip = function () {
            window.clearInterval(_this._rotatingTipInterval);
        };
        this.startRotatingTip = function () {
            _this._rotatingTipInterval = window.setInterval(function () {
                _this._currentIndex = (_this._currentIndex + 1) % _this._numberOfTipsToShow;
                _this.$timeout();
            }, 5000);
        };
        this.resetRotatingTip = function () {
            window.clearInterval(_this._rotatingTipInterval);
            _this.startRotatingTip();
        };
        this._tipsList = [
            {
                header: "Try this out!",
                content: "Use images to break up sections with a lot of content",
            },
            {
                header: "Try this out!",
                content: "Upsell your services and try a multi-select Quote Block or make line items optional",
            },
            {
                header: "Try this out!",
                content: "Preview your accept flow to view what your clients sees",
            },
            {
                header: "Try this out!",
                content: "End your documents with a clear call-to-action to encourage your audience to follow up",
            },
            {
                header: "Try this out!",
                content: "Use a video to increase your chance of conversion by 80%",
            },
        ];
        this._selectedTips = lodash_1.default.sampleSize(this._tipsList, this._numberOfTipsToShow);
        this._currentIndex = 0;
        this.$timeout = $timeout;
        $timeout(function () {
            _this.startRotatingTip();
        }, 2000);
    }
    Object.defineProperty(RandomTips.prototype, "currentIndex", {
        get: function () {
            return this._currentIndex;
        },
        set: function (index) {
            this._currentIndex = index;
            this.resetRotatingTip();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RandomTips.prototype, "currentTip", {
        get: function () {
            return this._selectedTips[this._currentIndex];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RandomTips.prototype, "selectedTips", {
        get: function () {
            return this._selectedTips;
        },
        enumerable: false,
        configurable: true
    });
    return RandomTips;
}());
exports.default = RandomTips;
